import { type ApolloError, useSubscription } from '@apollo/client'
import { useEffect } from 'react'

import logger from '@/utils/logger'

import { useUser } from '@/client/context/user'
import type {
  RealtimeConversationsListSubscription,
  RealtimeConversationsListSubscriptionVariables,
} from '@/client/services/hasura/generated/graphql'

import { REALTIME_CONVERSATIONS_SUBSCRIPTION } from './useRealtimeConversations.hasura'

export default function useRealtimeAIGuideConversations(): {
  loading: boolean
  error: ApolloError | null
  conversations: RealtimeConversationsListSubscription['conversation'] | null
} {
  const currentUser = useUser()

  const { loading, error, data } = useSubscription<
    RealtimeConversationsListSubscription,
    RealtimeConversationsListSubscriptionVariables
  >(REALTIME_CONVERSATIONS_SUBSCRIPTION, {
    variables: {
      currentUserId: currentUser.id,
      where: {
        type: { _eq: 'series-ai' },
        conversation_users: {
          user_id: { _eq: currentUser.id },
          archived_at: { _is_null: true },
        },
      },
    },
    onError: err => {
      logger.warning('Error fetching existing conversations', { err })
    },
  })

  useEffect(() => {
    if (error != null) {
      logger.error('Error loading conversations', { error })
    }
  }, [error])

  const conversations = data?.conversation

  return {
    loading,
    error: error ?? null,
    conversations: conversations ?? null,
  }
}
